import { render, staticRenderFns } from "./ns-datepicker.vue?vue&type=template&id=60c6ec24&"
import script from "./ns-datepicker.vue?vue&type=script&lang=js&"
export * from "./ns-datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports